import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sumByLength',
    pure: true // puoi mettere false se vuoi aggiornamento anche con modifiche mutative
    ,
    standalone: false
})
export class SumByLengthPipe implements PipeTransform {
  transform(items: any[], property: string): number {
    if (!items || !Array.isArray(items)) return 0;

    return items.reduce((acc, item) => {
      const arr = item[property];
      return acc + (Array.isArray(arr) ? arr.length : 0);
    }, 0);
  }
}
